import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';

import {cx} from '@emotion/css';
import LayoutSection from '../../DesignSystem/Layout/LayoutSection/LayoutSection';
import {LayoutBackground} from '../../DesignSystem/Layout/LayoutSection/LayoutSection.types';
import SectionTitleAndSubtitle from '../../DesignSystem/SectionTitleAndSubtitle/SectionTitleAndSubtitle';
import {Locale, useLocale} from '../../../RootProvider/LocaleContext';
import RenderOnLocales from '../../../RenderOnLocales';
import Button, {ButtonVariant} from '../../DesignSystem/Buttons/Button/Button';

import partnersImage from '../../../images/homepage/homepagePartners.png';
import partnersImageNL from '../../../images/homepage/homepagePartners-NL.png';

import styles from './Partners.styles';

function PartnersLink(): ReactElement {
  const {formatMessage} = useIntl();
  return (
    <Button
      variant={ButtonVariant.PRIMARY}
      ariaLabel={formatMessage({id: 'homepage.partners.cta'})}
      href={formatMessage({id: 'phoenix.urls.partner'})}
    >
      <FormattedMessage id="homepage.partners.cta" />
    </Button>
  );
}

function Partners(): ReactElement {
  const {formatMessage} = useIntl();
  const locale = useLocale();

  const getImageFromLocale = () => {
    switch (locale) {
      case Locale.nl:
        return partnersImageNL;

      case Locale.uk:
      default:
        return partnersImage;
    }
  };

  return (
    <LayoutSection innerClassName={cx(styles.homepagePartners)} type={LayoutBackground.GRAY}>
      <div className={cx(styles.content)}>
        <SectionTitleAndSubtitle
          className={cx(styles.sectionTitle)}
          title={formatMessage({id: 'homepage.partners.title'})}
          text={formatMessage({id: 'homepage.partners.description'})}
        />
        <RenderOnLocales locales={[Locale.uk]}>
          <PartnersLink />
        </RenderOnLocales>
      </div>
      <div className={cx(styles.supportingInfo)}>
        <img
          className={cx(styles.image)}
          alt={formatMessage({id: 'homepage.partners.imageDescription'})}
          src={getImageFromLocale()}
        />
      </div>
    </LayoutSection>
  );
}

export default Partners;
